const ITEMS = [
    {
        tag: "01 // VISUAL",
        title: "Design Personalizado",
        description:
            "Layouts exclusivos criados para expressar a identidade única do seu negócio.",
    },
    {
        tag: "02 // ADAPTAÇÃO",
        title: "Experiência Responsiva",
        description:
            "Navegação fluida e consistente em celular, tablet e computador.",
    },
    {
        tag: "03 // UX",
        title: "Navegação Intuitiva",
        description:
            "Estrutura clara para guiar o visitante até o contato sem atritos.",
    },
    {
        tag: "04 // PARCERIA",
        title: "Comunicação Próxima",
        description:
            "Atendimento direto e transparente durante todas as etapas do projeto.",
    },
    {
        tag: "05 // ESTRATÉGIA",
        title: "Alinhado aos Objetivos",
        description:
            "Desenvolvimento alinhado aos objetivos de cada negócio, do layout ao conteúdo.",
    },
    {
        tag: "06 // REFINAMENTO",
        title: "Atenção aos Detalhes",
        description:
            "Cuidado minucioso com os detalhes visuais e funcionais de cada página.",
    },
];

export const Diferenciais = () => {
    return (
        <section data-testid="diferenciais-section" className="py-24 border-b border-[#1e2430]">
            <div className="max-w-6xl mx-auto px-6">
                <div className="text-center max-w-2xl mx-auto mb-16">
                    <span className="code-font text-xs text-[#2563eb] uppercase tracking-wider block mb-2">
                        03 / Diferenciais
                    </span>
                    <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white mb-3">
                        Mais do que um site, uma experiência digital.
                    </h2>
                    <p className="text-slate-400 text-sm">
                        Cada detalhe é planejado para valorizar a sua marca.
                    </p>
                </div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {ITEMS.map((item, index) => (
                        <div
                            key={item.tag}
                            data-testid={`diferencial-card-${index}`}
                            className="p-6 rounded-xl bg-[#111622] border border-[#1e2738] hover:border-[#2563eb]/40 transition-colors"
                        >
                            <div className="code-font text-xs text-blue-400 mb-3">{item.tag}</div>
                            <h3 className="text-base font-bold text-white mb-2">{item.title}</h3>
                            <p className="text-xs text-slate-400 leading-relaxed">
                                {item.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
